<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات دسته بندی مقاله"
        >
          <b-form
            ref="blogcategoryform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2 form-size"
                md="8"
              >
                <b-row>

                  <b-col
                    class="image"
                    cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                          ref="previewEl"
                          :src="Form.Image"
                          size="90px"
                          rounded
                          button
                          @click="$refs.refInputEl.click()"
                        >
                          <feather-icon
                            v-if="Form.Image == null"
                            size="24"
                            icon="ImageIcon"
                          />
                        </b-avatar>
                      </template>
                      <input
                        :ref="'refInputEl'"
                        type="file"
                        class="d-none"
                        name="Image"
                        @input="imageRenderer($event)"
                      >
                      <b-row>
                        <b-col md="8">
                          <b-form-group
                            label="عنوان"
                            label-for="Title"
                            class="mb-0"
                          >
                            <b-form-input
                              id="Title"
                              v-model="Form.Title"
                              name="Title"
                              autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group
                            label="وضعیت"
                            label-for="IsActive"
                            class="mb-0"
                          >
                            <v-select
                              v-model="Form.IsActive"
                              :options="enums('IsActive')"
                              dir="rtl"
                              label="text"
                              :reduce="x => x.value"
                              :clearable="false"
                            />
                          </b-form-group>
                        </b-col>

                      </b-row>
                    </b-media>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <z-quill-editor v-model="Form.Description" />
                    </b-form-group>
                  </b-col>

                  <z-seo v-model="Form" />

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import ZSeo from '@/tools/seo.vue'
import ZQuillEditor from '@/tools/quilleditor.vue'

export default {
  name: 'BlogCategoryDetails',
  components: { ZQuillEditor, ZSeo },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Description: null,
        IsActive: true,
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.blogcategory.add
      if (this.$route.params.id) {
        url = this.$api.blogcategory.update
      }

      const formData = new FormData(this.$refs.blogcategoryform)
      formData.append('Id', this.Form.Id)
      formData.append('IsActive', this.Form.IsActive)

      if (this.Form.Description) {
        formData.append('Description', this.Form.Description)
      }

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.blogcategory.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
